export default __webpack_public_path__ + "static/media/hang-up.1c6417a5.mp3";